"use client"
import React, { useState, useCallback, useMemo } from 'react';
import Modal from 'react-bootstrap/Modal';
import { StyledVideoTour } from '@/components/common/ygen/sections/video-tour/video-tour.style.sj';
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const Sustainability = ({ link }) => {
	const [open, setOpen] = useState(false);
	const [videoId, setVideo] = useState(link);
	const [show, setShow] = useState(false);

	// Memoize the video URL
	const videoUrl = useMemo(() => {
		return `https://www.youtube.com/embed/${link}?si=H1t21Ym3px2yQicH;controls=0&autoplay=1`;
	}, [link]);

	// Optimize event handlers with useCallback
	const handleOpen = useCallback((open, id) => {
		setOpen(open);
		setVideo(id);
		setShow(true);
	}, []);

	const handleClose = useCallback(() => {
		setShow(false);
	}, []);

	const handleShow = useCallback((e) => {
		setShow(true);
		setPopupId(e);
		setVideo(true);
	}, []);

	const handleCloseModal = useCallback(() => {
		setOpen(false);
		setVideo('');
		handleClose();
	}, [handleClose]);
	const dispatch = DispatchCursor()

	return (
		<StyledVideoTour className="video-tour">
			<div onMouseEnter={() => CURSOR_TEXT(dispatch, 'Play')} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')} onClick={() => handleOpen(true, link)} className="video-tour-wrapper">
				<div className="content">
					<p>Take a <br /> Video Tour</p>
					<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="30" cy="30" r="30" fill="#DD223F" />
						<circle className="cursor_hover" cx="30" cy="30" r="0" fill="#152637" />
						<path d="M37 28.2679C38.3333 29.0377 38.3333 30.9623 37 31.7321L28 36.9282C26.6667 37.698 25 36.7358 25 35.1962L25 24.8038C25 23.2642 26.6667 22.302 28 23.0718L37 28.2679Z" fill="#D9D9D9" />
					</svg>
				</div>
				<div className="img">
					<img src="/images/dynamic/videotour.png" alt="Video Tour" />
				</div>
			</div>

			<Modal className="modal-video" show={show} onHide={handleClose}>
				<svg onClick={handleClose} className="close-modal" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd" d="M0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L7.29472 8.00183L0.146447 15.1501C-0.0488155 15.3454 -0.0488155 15.662 0.146447 15.8572C0.341709 16.0525 0.658291 16.0525 0.853553 15.8572L8.00183 8.70894L15.1501 15.8572C15.3454 16.0525 15.662 16.0525 15.8572 15.8572C16.0525 15.662 16.0525 15.3454 15.8572 15.1501L8.70894 8.00183L15.8572 0.853553C16.0525 0.658291 16.0525 0.341709 15.8572 0.146447C15.662 -0.0488155 15.3454 -0.0488155 15.1501 0.146447L8.00183 7.29472L0.853553 0.146447Z" fill="white" />
				</svg>

				<Modal.Body className="video">
					<iframe
						width="560"
						height="315"
						src={videoUrl}
						title="YouTube video player"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						allowFullScreen
					/>
				</Modal.Body>
			</Modal>
		</StyledVideoTour>
	);
};


export default React.memo(Sustainability);
